import React, { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { Editor } from "./editor";
import { Render } from "@measured/puck";
import { config } from "./puck.config";
export default function ContentEditor({ title, content, setContent }) {
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const publishContent = (content) => {
    setLoading(true);
    setContent(content).then(() => {
      setLoading(false);
      setModalVisible(false);
    });
  };

  return (
    <div>
      <Button
        variant="outline-primary"
        size="sm"
        onClick={() => setModalVisible(true)}
      >
        {content ? "Edit Content" : "Add Content"}
      </Button>
      <Modal
        backdrop="static"
        fullscreen
        show={modalVisible}
        onHide={() => setModalVisible(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Content Editor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="d-flex h-100 w-100 align-items-center justify-content-center position-absolute top-0 start-0 z-index-99999 ">
              <Spinner animation="border" />
            </div>
          ) : (
            <Editor
              title={title}
              content={content}
              setContent={publishContent}
            />
          )}
        </Modal.Body>
      </Modal>

      {!modalVisible && content && (
        <div className="my-4 ">
          <h3>Preview</h3>
          <div className="my-4 border-1">
            <Render config={config} data={content} />
          </div>
        </div>
      )}
    </div>
  );
}
